import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HourglassFullIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hourglass_full"}/>
}
